import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { StoresService } from '../appServices/stores.service';
import { StorageService } from '../appServices/storage.service';
import { StorageKeys } from '../appServices/storage-keys';

@Injectable({
    providedIn: 'root'
})
export class StoreResolver {
    store = new BehaviorSubject<any>(null);

    constructor(
        private storesService: StoresService,
        private storageService: StorageService
    ) { }

    /**
     * get store details by id
     * @param storeId  
     */
    async getStore(storeId: number): Promise<void> {
        const res = await firstValueFrom(this.storesService.getStoreById(storeId));
        this.store.next(res);
        await this.setSelectedStore(res);
    }

    /**
     * set selected store
     * @param store 
     */
    public async setSelectedStore(store: any): Promise<void> {
        await this.storageService.setItem(StorageKeys.STORE, store);
    }

    /**
     * get selected store
     * @returns 
     */
    public async getSelectedStore(): Promise<any> {
        return await this.storageService.getItem<any>(StorageKeys.STORE) || {};
    }
}